<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Notifications" title="Notifications" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-9 d-flex">
										<span style="font-size: 20px; font-weight: bolder;">Manage Notifications</span>
									</div>
									<div class="col-md-3">
										<button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Notification</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex">
										<label class="d-flex listing-length"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchNotifications()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-3">
											<!-- <div class="dropdown">
												<button class="dropbtn btn-primary" type="button">All Brands <span><i class="icofont icofont-arrow-down"></i></span></button>
												<div class="dropdown-content"><a href="#">Action</a><a href="#">Another Action</a><a href="#">Something Else Here</a></div>
											</div> -->
											<select class="form-select">
												<option value="all">General notifications</option>
												<option value="user">Users notifications</option>
											</select>
									</div>
										<div class="col-md-3">
											<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchNotifications()"/>
										</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-sort="ascending" aria-label="Title: activate to sort column descending"
												style="width: 303.766px;">Title</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Notification: activate to sort column ascending"
												style="width: 468.172px;">Notification</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Users: activate to sort column ascending"
												style="width: 215.25px;">User</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Created on: activate to sort column ascending"
												style="width: 215.266px;">Created on</th>		
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Options: activate to sort column ascending"
												style="width: 285.266px;">Options</th>	
										</tr>
									</thead>
									<tbody v-if="Boolean(notifications.length)">
										<tr v-for="noti in notifications" :key="noti.id">
											<td>{{ noti.title }}</td>
											<td>{{ noti.description }}</td>
											<td>
												<label v-if="noti.user_id">{{ noti.user_name }}</label>
												<label v-else>For all users</label>
											</td>
											<td>{{$filters.formatDateTime(noti.created_at) }}</td>
											<td>
												<button type="button" class="btn btn-primary mt-2 me-1 btn-sm" @click="editNotification(noti)">Edit</button>
												<button type="button" class="btn btn-danger btn-sm mt-2 me-1" @click="deleteNotification(noti.id)">Delete</button>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchNotifications(page.url + '&limit=' + listing_length + '&type=' + type + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal title="Add Notification">
			<template #body>
				<form @submit.prevent="addNotification" enctype="multipart/form-data">
					<div class="col-md-12 form-group">
						<label class="control-label">Title <span class="required">*</span></label>
						<input class="form-control" type="text" v-model="notification.title" :class="{ 'is-invalid': Boolean(errors.title) }"/>
						<div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Description <span class="required">*</span></label>
						<textarea v-model="notification.description" class="form-control" rows="3" :class="{ 'is-invalid': Boolean(errors.description) }"></textarea>
						<div v-for="(val, index) in errors.description" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Notification for <span class="required">*</span></label>
						<div class="radio radio-primary">
							<input v-model="notification_type" :value="0" id="radio1" type="radio" name="radio1">
							<label for="radio1">All Users</label>
							<input v-model="notification_type" :value="1" id="radio2" type="radio" name="radio2">
							<label for="radio2">Specific Users</label>
						</div>

						<div v-if="notification_type == 1">
							<div class="mb-3">
								<label class="control-label">User <span class="text-danger">*</span></label>
								<div class="search-select position-relative">
									<input v-model="user_keyword" class="form-control" @keyup="fetchUsers" autocomplete="off" placeholder="Search here..." :class="{ 'is-invalid': Boolean(errors.user_id) }"/>
									<div v-for="(val, index) in errors.user_id" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
									
									<ul v-if="visible && users.length" class="dropdown-menu show position-absolute w-100">
										<li v-for="user in users" :key="user.id" @click="setUser(user)" class="dropdown-item">
											{{ user.name }} | {{ user.phone_number }}
										</li>
									</ul>

									<ul v-if="visible && !users.length" class="dropdown-menu show position-absolute w-100">
										<li class="dropdown-item disabled">No data results...</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12 form-group">
						<button type="submit" class="btn btn-primary me-3">{{ button_title }}</button>
						<button type="button" class="btn btn-light" @click="closeModal">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "NotificationPage",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				notifications: [],
				users: [],
				notification: {
					id: null,
					title: "",
					description: "",
					type: "",
					user_id: 0,
					id_user: null,
					user_name: "",
					user_phone: "",
					user_email: "",
				},
				user_id: 0,
				notification_type: 0,
				visible: false,
				user_keyword: '',
				modal_title: "Add Notification",
				button_title: "Add",
				pagination: {},
				edit: false,
				type: "all",
				send_type: "",
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},
				
         		delete: false,
         		active_page_url: null,
			};
		},
		created() {
			this.fetchNotifications();
			//this.fetchUsers();
		},
		methods: {

			closeSearch() {
				this.visible = false;
				//alert(this.notification.user_id);
				//alert(this.notification.user_name);

				if(this.edit) {
					if(this.notification.user_id) {
						this.user_keyword = this.notification.user_name + ' | ' + this.notification.user_phone;
						this.user_id = this.notification.user_id;
					} else {
						this.user_keyword = '';
						this.user_id = 0;
					}					 
					
				} else {
					this.user_keyword = '';
					this.user_id = 0;
				}
			},

			fetchNotifications(page_url = null) {
				let url = "/api/admin/notifications?limit=" + this.listing_length + "&type=" + this.type + "&keyword=" + this.keyword;
				page_url = page_url || url;

				this.active_page_url = page_url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.notifications = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			fetchUsers() {
				let url = "/api/admin/notifications/search_user?keyword=" + this.user_keyword;
				this.getToken();
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data;

						this.users = responseData.data;
						this.visible = true;
					})
					.catch((err) => console.log(err));
			},

			setUser(user) {
				this.user_keyword = `${user.name} | ${user.phone_number}`;
				this.notification.user_id = user.id;
				this.visible = false;
			},

			
			openModal() {
				this.showModal();
				this.clearForm();
			},

			closeModal() {
				this.clearForm();
				this.hideModal();
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },
			
			addNotification() {
				this.getToken();
				let formData = new FormData();
				formData.append("title", this.notification.title);
				formData.append("description", this.notification.description);
				 formData.append("user_id", this.notification_type ? this.notification.user_id : 0);
				
				
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/api/admin/notifications/add";
					this.active_page_url = null;
				} else {
					url = "/api/admin/notifications/edit";
					formData.append("notification_id", this.notification.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchNotifications(this.active_page_url);
					})
					.catch((error) => {
						console.log(error.response.data);

						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},
			
			editNotification(notification) {
				console.log(notification);
				
				this.edit = true;
				this.notification.id = notification.id;
				this.notification.title = notification.title;
				this.notification.description = notification.description;
				this.notification.user_name = notification.user_name;
				this.notification.user_phone = notification.user_phone;
				this.notification.country_code = notification.country_code;

				if (notification.user_id) {
					this.notification_type = 1;
					this.notification.user_id = notification.user_id;	
					this.user_id = notification.user_id;				
					this.user_keyword = notification.user_name + ' | ' + notification.user_phone;
					
				} else {
					this.notification_type = 0;
					this.notification.user_id = 0;
					this.user_keyword = '';
					this.user_id = 0;
				}
								
				this.errors = {};
				this.modal_title = "Edit Notification";
				this.button_title = "Update";
				this.showModal();
			},
			clearForm() {
				this.edit = false;
				this.notification.id = null;
				this.notification.title = "";
				this.notification.description = "";
				this.notification.user_id = 0;
				this.user_keyword = '';
				this.modal_title = "Add Notification";
				this.button_title = "Add";
				this.errors = {};
				this.user_id = 0;
				this.notification_type = 0;
				this.user_keyword = '';
			},

			deleteNotification(notification_id) {
			this.delete = false;
			this.$swal({
						icon: 'warning',
						title:"Confirm",
						text:'Are you sure you want to delete this notification?',
						showCancelButton: true,
						confirmButtonText: 'Yes',
						confirmButtonColor: '#e64942',
						cancelButtonText: 'No',
						position: "center",
						showConfirmButton: true,
						timer: '',
						toast: false,
						cancelButtonColor: '#efefef',
						}).then((result)=>{
					// this.delete = value
					if(result.value){
						this.getToken();
						this.$axios
							.get("/api/admin/notifications/delete?notification_id=" + notification_id, {headers: {Authorization: 'Bearer ' + this.token,}})
							.then(response => {
							if(response.data.status) {
									this.$swal("", response.data.message, "success");
							} else {
									this.$swal("", response.data.message, "error");
							}
							this.fetchNotifications();
							})
							.catch(err => console.log(err));
					}
				})   
			},

		},
	};
</script>